import moment from 'moment';

const BaselineHistoryColumn = [
  {
    title: 'No.',
    dataIndex: 'index',
    width: 100
  },
  {
    title: 'Webpage Name',
    dataIndex: 'webpageName',
    width: 250
  },
  {
    title: 'Webpage URL',
    dataIndex: 'webpageUrl',
    slot: 'webpageUrl',
    width: 250
  },
  {
    title: 'Baseline Date/Time',
    dataIndex: 'baselineAt',
    slot: 'baselineAt',
    width: 200,
    sorter: (a, b) => moment(a.baselineAt).diff(moment(b.baselineAt)),
  }
];

export { BaselineHistoryColumn };
